import React, { Component } from 'react';
import BestDev from './Tables/bestDev';
import Wrapper from './Wrapper/WrapperBestDevTable';
import WrapperGraph from './Wrapper/WrapperGraph';

import Slideshow from 'react-slidez';


class DownCarousel extends Component {



    render(){

        return (
            <Slideshow
                showIndex={false}
                showArrows={false}
                autoplay
                enableKeyboard
                useDotIndex
                slideInterval={30000}
                defaultIndex={1}
                slides={[<WrapperGraph key="wrapperGraphs"/>, <Wrapper key="wrapperTables"/>]}
                effect={'left'}
                height={'50%'}
                width={'98%'}
            >
                <BestDev/>
            </Slideshow>
        )
    }

}

export default (DownCarousel);



// WEBPACK FOOTER //
// ./src/components/DownCarousel.js